export const clearPhoneValidation = () => {
  window.localStorage.removeItem("phoneid");
  window.localStorage.removeItem("token");
};
